import React from 'react';

type Props = {
	info?: any;
};
const TableTotalBlock: React.FC<Props> = ({info}) => {
	if (info) {
		return (
			<div className="shopping-total">
				{info.map((i: any, index: number) => (
					<div
						key={index + new Date().getDate()}
						className="shopping-total__item"
					>
						<div className="shopping-total__label">{i?.title || ''}</div>
						<div className="shopping-total__total">
							{i?.data || ''}
							<span>{i?.currency || ''}</span>
						</div>
					</div>
				))}
			</div>
		);
	} else {
		return (
			<div>Nobody</div>
			/*<div className="shopping-total">
				<div className="shopping-total__item">
					<div className="shopping-total__label">СУММА В ГРН:</div>
					<div className="shopping-total__total">
						2880 <span>грн</span>
					</div>
				</div>
				<div className="shopping-total__item">
					<div className="shopping-total__label">КОЛИЧЕСТВО:</div>
					<div className="shopping-total__total">6</div>
				</div>
				<div className="shopping-total__item">
					<div className="shopping-total__label">БАЛЛОВ:</div>
					<div className="shopping-total__total">150 Б</div>
				</div>
			</div>*/
		);
	}
};

export default TableTotalBlock;
